import { Injectable, inject } from '@angular/core';
import { CultivationHierarchyApi } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/cultivation/cultivation-hierarchy/cultivation-hierarchy-api';
import { LocationApi } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/location/location-api';
import { MyCultivationHierarchyListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/cultivation/my-cultivation-hierarchy-list.response';
import { LocationListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/location-list.response';
import { StorageService } from '../front/storage.service';
import { DataStore } from './data-store.service';

/** Une adresse a rarement plus de quelques zones : une page suffit. */
const ZONES_PAGE_SIZE = 50;

/**
 * Le potager lu par plusieurs écrans : les cultures du compte (accueil,
 * onglet « Plantations (N) », Mon potager) et les zones d'une adresse (Mon
 * potager, cartes d'adresse du profil). Une ouverture de Mon potager lisait
 * deux fois les cultures, et l'accueil une troisième juste avant.
 *
 * Toute écriture sur le potager passe par le SDK, qui invalide `garden/`.
 */
@Injectable({ providedIn: 'root' })
export class GardenStore {
  // Les classes du SDK lisent leur configuration dans un singleton : on les
  // instancie directement, comme `PremiumService`.
  private readonly hierarchyApi = new CultivationHierarchyApi();
  private readonly locationApi = new LocationApi();
  private readonly data = inject(DataStore);
  private readonly storage = inject(StorageService);

  /** Les cultures du compte, avec leurs plantes, dans la langue de l'app ; gardées pour le hors ligne. */
  myGarden(): Promise<MyCultivationHierarchyListResponse[]> {
    const lang = this.storage.getCurrentLanguage();
    return this.data.get(`garden/my-garden:${lang}`, () => this.hierarchyApi.myGarden(lang), { persist: true });
  }

  /** Les zones d'une adresse (sans adresse connue, celles du compte) ; gardées pour le hors ligne. */
  zones(addressUid?: string): Promise<LocationListResponse[]> {
    const lang = this.storage.getCurrentLanguage();
    return this.data.get(
      `garden/zones:${addressUid}:${lang}`,
      async () => {
        const page = await this.locationApi.list({ addressUid } as any, 0, ZONES_PAGE_SIZE, lang);
        return page?.results ?? [];
      },
      { persist: true },
    );
  }
}
